import { render, staticRenderFns } from "./PickSettingMenu.vue?vue&type=template&id=150e5fd7&"
import script from "./PickSettingMenu.vue?vue&type=script&lang=ts&"
export * from "./PickSettingMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports